import React, { useState } from 'react'
import MainMenu from './MainMenu'
import { useTranslation } from 'react-i18next'
import {  FaHome, FaUserCircle } from 'react-icons/fa'
import { MdMenuOpen } from "react-icons/md"
import dayjs from 'dayjs'
import LanguageSwitcher from '../ui/LanguageSwitcher'

const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
	const { i18n} = useTranslation()
	const [open, setOpen] = useState<boolean>(false)

	dayjs.locale(i18n.language)



	return (
		<div
			className="text-black grid grid-cols-5 transition-all bg-gray-100"
			dir={i18n.language === "ar" ? "rtl" : "ltr"}
		>
			{/* القائمة الجانبية */}
			<div className={`${open ? 'block' : 'hidden'} sm:block lg:col-span-1`}>
				<div className="sticky top-0 h-screen overflow-y-auto bg-white shadow-md">
					<MainMenu onClose={setOpen} />
				</div>
			</div>

			{/* المحتوى */}
			<div
				className={`${open ? 'col-span-4' : 'col-span-5'} sm:col-span-4 transition-all `}
			>
				<header className="sticky  top-0 z-30 bg-white shadow-sm mb-5">
					<div className="flex items-center justify-between px-5 py-5">
						<div className="flex items-center gap-3">
							<button
								onClick={() => setOpen(!open)}
								className="sm:hidden text-gray-600 hover:text-gray-800"
							>
								<MdMenuOpen size={22} />
							</button>
							<FaHome className="text-gray-500" />
							<h1 className="text-lg font-semibold text-primary capitalize">
								LiBooking
							</h1>
						</div>

						{/* يمين: لغة + إشعارات + بروفايل */}
						<div className="flex items-center gap-4">
							<LanguageSwitcher />
							<button className="flex items-center gap-2 text-gray-700 hover:text-gray-900">
								<FaUserCircle size={24} />
								<span className="hidden sm:block text-sm font-medium">Admin</span>
							</button>
						</div>
					</div>
				</header>

				{/* محتوى الصفحة */}
				<div className="px-5 mb-10">{children}</div>
			</div>
		</div>
	)
}

export default DashboardLayout
